export default __webpack_public_path__ + "images/logoMzSkin.e73f78e36927443aa99488ebe9aff786.svg"